import { DownloadOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Descriptions, Modal, Spin, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { urlAdmin } from '../../constants';
import { KeKhaiTaiSan } from '../../models/taisan/KeKhaiTaiSan';
import { layChiTietKeKhai } from '../../services/keKhaiTaiSan';

const { Text } = Typography;

interface ModalXemKeKhaiTaiSanProps {
    open: boolean;
    idKeKhai: number | null;
    onClose: () => void;
}

const ModalXemKeKhaiTaiSan = ({ open, idKeKhai, onClose }: ModalXemKeKhaiTaiSanProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [data, setData] = useState<KeKhaiTaiSan | null>(null);

    useEffect(() => {
        if (open && idKeKhai && idKeKhai > 0) {
            loadChiTiet(idKeKhai);
        } else {
            setData(null);
        }
    }, [open, idKeKhai]);

    const loadChiTiet = async (id: number) => {
        setIsLoading(true);
        try {
            const res = await layChiTietKeKhai(id);
            setData(res);
        } catch (error: any) {
            toast.error(error.message || "Lỗi tải chi tiết kê khai tài sản");
        } finally {
            setIsLoading(false);
        }
    };

    const formatCurrency = (value?: number) => {
        if (value === undefined || value === null) return "0 đ";
        return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value);
    };

    return (
        <Modal
            title="Chi tiết kê khai tài sản"
            open={open}
            onCancel={onClose}
            width={700}
            footer={[
                <Button key="close" type="primary" onClick={onClose}>
                    Đóng
                </Button>
            ]}
        >
            <Spin spinning={isLoading}>
                {data && (
                    <Descriptions bordered column={2} size="small">
                        <Descriptions.Item label="Người kê khai" span={2}>
                            <Text strong>{data.tenNhanVien || "—"}</Text> {data.maNhanVien ? `(${data.maNhanVien})` : ""}
                        </Descriptions.Item>
                        <Descriptions.Item label="Đơn vị / Phòng ban" span={2}>
                            {data.tenDonVi || "—"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tên tài sản" span={2}>
                            <Text strong style={{ color: '#1890ff', fontSize: 15 }}>{data.tenTaiSan}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Năm hình thành">
                            {data.namHinhThanh}
                        </Descriptions.Item>
                        <Descriptions.Item label="Giá trị tài sản">
                            <Text strong style={{ color: '#52c41a' }}>{formatCurrency(data.giaTriTaiSan)}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Nguồn gốc" span={2}>
                            {data.nguonGoc || "—"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Ghi chú" span={2}>
                            {data.ghiChu || "—"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tệp đính kèm" span={2}>
                            {data.dsTaiLieu && data.dsTaiLieu.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                    {data.dsTaiLieu.map(file => {
                                        const fileUrl = urlAdmin + (file.duongDan || '').replace(/\\/g, '/');
                                        return (
                                            <div key={file.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 8px', background: '#fafafa', borderRadius: 4, border: '1px solid #f0f0f0' }}>
                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                    <PaperClipOutlined style={{ marginRight: 6, color: '#1890ff' }} />
                                                    {file.tenTep}
                                                </span>
                                                <a href={fileUrl} target="_blank" rel="noopener noreferrer" download>
                                                    <Button size="small" type="link" icon={<DownloadOutlined />}>Tải về</Button>
                                                </a>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <Text type="secondary">Không có tệp đính kèm</Text>
                            )}
                        </Descriptions.Item>
                    </Descriptions>
                )}
            </Spin>
        </Modal>
    );
};

export default ModalXemKeKhaiTaiSan;
